module.exports = __webpack_public_path__ + "img/Particules_volantes1.4153e5cc.svg";